<template>
  <div>
    <div class="header_top">
        <div class="header_center">
          <ul>
            <div style="float:left;">
                <li><a href="http://web.lusenky.com/">露森科研</a> </li>
                <li @click="$router.push('/')">露森课堂</li>
                <li>需求中心</li>
                <li>会议会展</li>
                <li>线下培训</li>
                <li>积分换购</li>
            </div>
            <div style="float:right;">
                 
                  <li class="index-head1-gu">关注我们
                     <div class="index-head1-er"><img width="100%" src="../../assets/logo/er3.jpg" alt=""></div>
                  </li>
                  <li>移动端</li>
                  <li>在线沟通</li>
                  <li v-if="!$store.state.isDeng">买家注册</li>
                  <li id="elment">
                   <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" v-if="$store.state.isDeng" >
                       <el-submenu index="2">
                         <template slot="title">个人中心  </template>
                         <el-menu-item index="2-1"  @click="$router.push('/order')">我的课程</el-menu-item>
                       </el-submenu>
                      </el-menu>
                  </li>
                  <li v-if="$store.state.isDeng" @click="tui">退出</li>
                  <li v-if="!$store.state.isDeng"  @click="isn=!isn">登录</li>
            </div>
         
          </ul>
        </div>
    </div>
  </div>
</template>

<script>
import tanc from '../tanc'
export default {
  data(){
    return{
      isLo:0,
      input:'',
      isn:false,
      activeIndex: '1',
      activeIndex2: '1'
    }
  },
  components:{
    tanc
  },
  methods:{
     handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
    // 鼠标移出
    changeActive($event){
           $event.currentTarget.className="active";
    },
    removeActive($event){
           $event.currentTarget.className="";
    },
    tiao(){
      if(this.$route.path!='/'){
        this.$router.push('/')
      }
    },
    /*推出登陆*/
    tui(){
      this.setCookie('id','',-1)
      location.reload()
    },
    search(){
      if(this.input.trim().length==0){
         this.$notify({
           title: '提示',
           message: ('搜索的内容不能为空')
        })
      }else{
        if(this.$route.path=='/seach'){
          this.$emit('chsear',this.input)
        }else{
          this.$router.push({path:"/seach",query:{search:this.input}})
        }
       }
     },
      /*setStorage(name,val){
           window.sessionStorage.setItem(name,val)
       },
       getStorage(name){
           var val=window.sessionStorage.getItem(name)
           return val
       },*/
       /*获取cookie */
       getDing(st,pa,id){
          this.axios.get('order/fen',{params:{
            start:st,
            pageSize:pa,
            uid:id
         }}).then((res)=>{
          var arr=res.data.map((val)=>{
            return val.course.cid
         })
         this.$store.commit('baoIds',arr)
       })
      },
       getCookie(name){
          let strCookie = document.cookie; 
          let arrCookie = strCookie.split(';'); 
          // 遍历匹配
          for (let i = 0; i < arrCookie.length; i++) {
              let temp = arrCookie[i].trim().split('=');
              if (temp[0] === name) {
                  return temp[1];
              }
          }
          return '';
       },
       setCookie(name, value, time){
        let currentTime = new Date().getTime();
        let expireTime = new Date(currentTime + time);
        document.cookie = name + "="+ value + ";expires=" + expireTime.toGMTString();        
      },
    /*判断是否登陆 */
    isLogin(){
         let id=this.getCookie('id')
         if(id!==''){
            this.getDing(1,10,id)
            this.$store.commit('dengLu')
            this.$store.commit('userIsId',id)
         }else{
           this.$store.commit('dengNo')
         }
       }
  },
  created(){
    this.isLogin()
  }
}
</script>
<style scoped>
.index-head1-gu:hover>.index-head1-er{
    display: block;
}
.index-head1-er{
    width: 90px;
    height: 90px;
    padding: 10px;
    background: #e5e5e5;
    display: none;
    position: absolute;
    z-index: 99999;
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 30px;
    line-height: 60px;
    border-bottom: 2px solid transparent;
    color: #909399;
}
/* 顶端头部样式 */
.header_top{
  background: #f5f5f5;
  width:100%;
  height:37px;
}
.header_center{
  width:1200px;
  height:37px;
  margin:0 auto;
}
.header_center ul{
  /* float: right; */
}
.header_center ul li{
    float: left;
    line-height: 37px;
    font-size: 12px;
    color: #4a4a4a;
    text-align: center;
    width: 90px;
    cursor:pointer;
}
@media screen and (max-width: 767px){
 /*.header>.input{
  box-sizing: border-box;
  padding:0 0.6rem;
}*/
 .disnone{
   display: none;
 }
/* .ii{
   left:7% !important;
 }*/
}
/*@media screen and (min-width:768px){
 .header>div{
  box-sizing: border-box;
 }
}*/
.header{
  width: 1200px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 23px 0 17px;
  font-size: 14px;
}
.input{
  position: relative;
  margin-top:1%;
}
.input>input{
width: 86%;
outline: none;
box-sizing: border-box;
padding:0.6rem 2rem;
border-radius: 18px;
border:1px solid #5E2D89;
}
.input>span{
  width: 20%;
  min-width: 50px;
  position: absolute;
  right: 3%;
  height: 100%;
  box-sizing: border-box;
  display: inline-block;
  background: #5E2D89;
  color:white;
  text-align: center;
  line-height: 35px;
  border-top-right-radius:16px;
  border-bottom-right-radius:18px;
  cursor: pointer;
}
.ii{
position: absolute;
left:2%;
top:20%;
font-size: 1.2rem;
color: #b9b4b4;
}
.i1{
cursor: pointer;
}
.de{
  height: 2rem;
  text-align: center;
  margin-top:1%;
}
.de>img{
  display: block;
  margin:0 auto;
}
.list{
  position: relative;
  cursor: pointer;
  background: #c1c1c1;
  overflow: hidden;
  transition: .5s;
  z-index: 999999;
}
.list>li{
  padding: 6px 0;
}
.list>li:hover{
  background: #5E2D89;
  color: #fff;
  
}
</style>